<editor style="height: 500px;" [(ngModel)]="text" apiKey="y03bmalsbul8c8jwnk1rneuw8jqlcdoa99ptm95jtrz4fri6"></editor>
